<template>
  <div
    v-bind="$attrs"
    class="AmbiCardWrapper"
    @click.self="close"
    ref="AmbiCard"
    :style="calculatedStyles"
  >
    <slot v-bind="{ close }"></slot>
  </div>

  <div class="AmbiCardOverlay" @click.self="close"></div>
</template>

<script>
import { useAmbiCard } from '../composables/AmbiCard'

export default {
  setup() {
    const { visible, open, close, toggle, transitionState } = useAmbiCard()

    return {
      visible,
      open,
      close,
      toggle,
      transitionState
    }
  },

  props: {
    fixedButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      priceType: 'fromSelect' /* fromSelect = <aw-select>, custom = <input> */
    }
  },
  methods: {
    visibleWatcher(visible) {
      this.$nextTick(() => {
        this.$refs.AmbiCard.classList[visible ? 'add' : 'remove']('-Opened')
      })
    },
    transitionEnd(e) {
      if (e.target.matches('.AmbiCard')) {
        if (this.transitionState === 'closed') {
          this.transitionState = 'opened'
        } else if (this.transitionState == 'opened') {
          // pro drobne zpozdeni
          setTimeout(() => {
            this.transitionState = 'closed'
          }, 50)
        }
      }
    },
    closeOnEscape(e) {
      if (e.key === 'Escape') {
        this.close()
      }
    },
    selectValue(val) {
      if (val === 999) {
        this.setPriceView('custom')
      }
    },
    setPriceView(type) {
      this.priceType = type
    },
    openAmbiSelect() {
      // this.$refs.AmbiSelect.openSelect()
    }
  },
  computed: {
    defaultColors() {
      return {
        bg: '#c8102e',
        fg: '#fff'
      }
    },

    calculatedStyles() {
      return {
        '--bg-color':
          this.$controls?.ambiStickyCard?.voucher?.bg_sticky_card?.color || this.defaultColors.bg,
        '--bg-color-darken': this.$controls?.ambiStickyCard?.voucher?.bg_sticky_card?.color
          ? `color-mix(in srgb, ${this.$controls?.ambiStickyCard?.voucher?.bg_sticky_card?.color} 85%, black)`
          : `color-mix(in srgb, ${this.defaultColors.bg} 85%, black)`,
        '--fg-color':
          this.$controls?.ambiStickyCard?.voucher?.fg_sticky_card?.color || this.defaultColors.fg
      }
    }
  },
  watch: {
    visible(newValue) {
      this.visibleWatcher(newValue)
    }
  },
  mounted() {
    document.addEventListener('keydown', this.closeOnEscape)
    this.$refs.AmbiCard.addEventListener('transitionend', this.transitionEnd)
  },
  unmounted() {
    document.removeEventListener('keydown', this.closeOnEscape)
    // this.$refs.AmbiCard.removeEventListener('transitionend', this.transitionEnd)
  }
}
</script>

<style lang="scss">
.AmbiCardWrapper {
  @apply fixed bottom-0 left-0 right-0 flex justify-end;

  z-index: 101;
}
.AmbiCard {
  background: var(--bg-color);
  @apply p-4 pt-2 pb-0;
  @apply fixed right-0 bottom-0 h-full;
  translate: 0 calc(100% - 0px);
  width: min(440px, 100%);
  transition: translate 400ms ease-in-out;
}

.AmbiCard__Header {
  color: var(--fg-color);
  @apply flex items-center justify-between;
}

.AmbiCard__Content {
  color: var(--fg-color);
  @apply flex py-2 gap-x-2;
  @apply overflow-y-auto;
  max-height: calc(100% - 25px);
}

.AmbiCardOverlay {
  @apply fixed inset-0;
  @apply bg-black bg-opacity-30;
  @apply invisible opacity-0;
  z-index: 100;
  transition: 350ms ease;
}

// is opened
.-Opened {
  .AmbiCard {
    translate: 0 0;
  }
}

.-Opened + .AmbiCardOverlay {
  @apply opacity-100 visible;
}

.ImageScale {
  width: clamp(80px, 25vh, 250px); // mobil, dynamic default, max
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.v-enter-active {
  transition: 0.3s ease-in-out;
}

.v-enter-from {
  opacity: 0;
  scale: 0;
}
</style>
